import { ca } from '@cian/analytics';

export type IProducts = Array<{
  id: number;
  offerType: string;
  position: number;
}>;

export function trackBannerClick(products: IProducts) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'ChatBot_banner',
    products,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        trap_type: 'cian_helper',
        bannerName: 'Циан.Помощник',
        trapid: 'Циан.Помощник',
      },
    },
  });
}

export function trackBannerShow(products: IProducts) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'ChatBot_banner',
    products,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        trap_type: 'cian_helper',
        bannerName: 'Циан.Помощник',
        trapid: 'Циан.Помощник',
      },
    },
  });
}
